import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import {
    AisRestService,
    CaseResource,
    CaseResourceIdentifier,
    ConditionDisclosureResource,
    DisclosureSource,
    InterviewDisclosureIdentifier,
    QuestionAnswerType,
    ReflexiveAnswerType,
    ReflexiveQuestionResource
} from '@Components/mras/core';
import { ObservableService } from '@Services';

@Component({
    selector: 'jhi-questions-reflexive',
    templateUrl: './questions-reflexive.component.html',
    styles: []
})
export class QuestionsReflexiveComponent implements OnInit {
    readonly QuestionAnswerType = QuestionAnswerType;
    readonly DisclosureSource = DisclosureSource;
    readonly ReflexiveQuestionType = ReflexiveAnswerType;

    @Input()
        summaryMode: boolean;
    @Input()
        disclosureSource: DisclosureSource;

    @Input()
        disclosureIdentifier: InterviewDisclosureIdentifier;
    @Input()
        disclosure: ConditionDisclosureResource;
    @Output()
        disclosureChange = new EventEmitter<ConditionDisclosureResource>();
    @Output()
        onRemove = new EventEmitter<string>();
    @Output()
        onRemoveTriggeredDisclosure = new EventEmitter<string[]>();
    @Output()
        onUpdate = new EventEmitter<string>();
    @Input()
        showDisclosureName: boolean;
    @Input()
        caseDetails: CaseResource;
    disclosureName: string;
    httpErrorMsg: string;

    constructor(private aisRestService: AisRestService,
        public observableService: ObservableService
    ) {}

    ngOnInit(): void {
        this.disclosureName = this.disclosure.aliasName;
        const caseIdentifier = new CaseResourceIdentifier();
        caseIdentifier.caseId = this.disclosureIdentifier.caseId;
    }

    answerReflexiveQuestion(currentQuestion: any, answerHasChanged: boolean) {
        this.httpErrorMsg = null;        
        
        const disclosureQuestion = this.disclosure.questions.find(x => x.code === currentQuestion.code);
        const answerVal = disclosureQuestion.answerValue;

        if (answerHasChanged) {
            disclosureQuestion.answerValue = null;        
        }
        
        this.submitReflexiveQuestion(answerHasChanged, currentQuestion, answerVal);  
    }

    submitReflexiveQuestion(answerHasChanged: boolean, currentQuestion, currentValue) {
        const resource = new ConditionDisclosureResource();
        let question = new ReflexiveQuestionResource();

        let breakLoop = false;

        resource.questions = this.disclosure.questions.map(e => {
            if (e.answerType !== 'PICK_LIST' && !breakLoop) {
                question = new ReflexiveQuestionResource();
                question.answerValue = e.answerValue;
                
                if (e.code === currentQuestion.code) {
                    breakLoop = true;
                }

                return question;
            } else {
                question.triggeredAliases = e.triggeredAliases;
            }

            
        });

        resource.questions = resource.questions.filter( x=> x && x !== null && x.answerValue !== undefined);

        const existingTriggeredAliases = this.disclosure.triggeredCondAliases;
        this.aisRestService.answerReflexiveQuestion(this.disclosureIdentifier, resource).subscribe(
            answerReflexiveQuestionResp => {                
                if (answerReflexiveQuestionResp.errorCode && answerReflexiveQuestionResp.errorCode !== '') {
                    this.httpErrorMsg = answerReflexiveQuestionResp.errorCode;
                    return;
                }

                Object.keys(this.disclosure).forEach(f => delete this.disclosure[f]);
                Object.assign(this.disclosure, answerReflexiveQuestionResp);
                this.disclosureChange.emit(this.disclosure);

                if (existingTriggeredAliases?.sort().toString() !== this.disclosure.triggeredCondAliases?.sort().toString()) {
                    const removedDisclosures = [];
                    for (const existingTriggeredAlias of existingTriggeredAliases) {
                        if (this.disclosure.triggeredCondAliases.indexOf(existingTriggeredAlias) < 0) {
                            removedDisclosures.push(existingTriggeredAlias);
                        }
                    }
                    this.onRemoveTriggeredDisclosure.emit(removedDisclosures);
                    this.onUpdate.emit(this.disclosure.aliasName);
                }

                if (answerHasChanged) {
                    this.disclosure.questions.find(x => x.code === currentQuestion.code).answerValue = currentValue;   
                    this.submitReflexiveQuestion(false, currentQuestion, currentValue);
                }

                this.observableService.onMrasQuestionUpdated.next(1);
            },
            errMsg => (this.httpErrorMsg = errMsg)
        );
    }

    isRemovable(): boolean {
        if (
            this.disclosure.removableFromBqCodes == null ||
            this.disclosure.removableFromBqCodes.length == 0 ||
            this.disclosureSource !== DisclosureSource.SEARCH
        ) {
            return false;
        }
        return this.disclosure.removableFromBqCodes.indexOf(this.disclosureIdentifier.baseQuestionCode) > -1;
    }

    onRemoveClick() {
        this.onRemove.emit(this.disclosureName);
    }
}
